/* eslint-disable */
// @ts-nocheck
import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';
import { ActionNamespaceConstants } from '../../types/reduxAsyncAction';
import NotificationActions from '../NotificationActions';

const FETCH_ORIGINAL_WEB_URL_LINK_DATA_NAMESPACE = 'FETCH_ORIGINAL_WEB_URL_LINK_DATA' as const;
const FetchOriginalWebUrlLinkData = new ReduxAsyncAction(FETCH_ORIGINAL_WEB_URL_LINK_DATA_NAMESPACE);
FetchOriginalWebUrlLinkData.registerRequest(async (originalWebUrl: string) => {
  try {
    const { data } = await dash_api.post('/v1/scraper/metadata', {
      uri: originalWebUrl,
    });

    if (data.link_data) {
      data.link_data.$canonical_url = data.link_data_$canonical_url || originalWebUrl;
    }

    return { ...data };
  } catch (error) {
    throw error;
  }
});

export const FETCH_ORIGINAL_WEB_URL_LINK_DATA: ActionNamespaceConstants<typeof FETCH_ORIGINAL_WEB_URL_LINK_DATA_NAMESPACE> =
  FetchOriginalWebUrlLinkData.constants;
export const fetchOriginalWebUrlLinkData = FetchOriginalWebUrlLinkData.request;

const UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS_NAMESPACE = 'UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS' as const;
const UpdateOriginalWebUrlLinkDataStatus = new ReduxAsyncAction(UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS_NAMESPACE);
UpdateOriginalWebUrlLinkDataStatus.registerRequest(async (originalWebUrlLinkDataStatus: number) => {
  return { originalWebUrlLinkDataStatus };
});

export const UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS: ActionNamespaceConstants<
  typeof UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS_NAMESPACE
> = UpdateOriginalWebUrlLinkDataStatus.constants;
export const updateOriginalWebUrlLinkDataStatus = UpdateOriginalWebUrlLinkDataStatus.request;

const FETCH_ALL_LINK_COLLECTIONS_NAMESPACE = 'FETCH_ALL_LINK_COLLECTIONS' as const;
const FetchAllLinkCollections = new ReduxAsyncAction(FETCH_ALL_LINK_COLLECTIONS_NAMESPACE);
FetchAllLinkCollections.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/linkhub/collections');
    return {
      allLinkCollections: response?.data,
    };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch all link collections.', 'error');

    throw error;
  }
});

export const FETCH_ALL_LINK_COLLECTIONS: ActionNamespaceConstants<typeof FETCH_ALL_LINK_COLLECTIONS_NAMESPACE> =
  FetchAllLinkCollections.constants;
export const fetchAllLinkCollections = FetchAllLinkCollections.request;
